export const LANGUAGES = {
  en: 'en-US',
  nl: 'nl-BE',
};
